import { resolveBoxAccess, type CustomClaims } from "@lemonadetraining/contracts";

export type ProgrammeRef = {
  boxID?: string | null;
  CoachUID?: string | null;
  ownerUID?: string | null;
};

export type ProgrammeManageLane = "creator" | "admin" | "coach" | null;

export const isProgrammeCreator = (uid: string, programme: ProgrammeRef): boolean =>
  uid === programme.CoachUID || uid === programme.ownerUID;

/**
 * "coach" means eligible pending the box-granted canCreatePrograms permission,
 * which the caller resolves from the Members document. The coach arm still
 * keys on the legacy claim pair because that is what the card write callables
 * accept for coaches. Gym owners always carry the admin role claim.
 */
export const resolveProgrammeManageLane = (
  claims: Partial<CustomClaims> | null | undefined,
  uid: string | null | undefined,
  programme: ProgrammeRef
): ProgrammeManageLane => {
  if (!uid) return null;
  if (isProgrammeCreator(uid, programme)) return "creator";
  if (!programme.boxID) return null;
  const access = resolveBoxAccess(claims);
  if (access.boxID !== programme.boxID) return null;
  if (access.isBoxAdmin) return "admin";
  if (claims?.boxCoach === true && claims?.coachType === "box") return "coach";
  return null;
};

/** editRightsEnforced: only the creator and the gym's admins manage a gym programme. */
export const canManageProgramme = (
  lane: ProgrammeManageLane,
  coachHasGrant: boolean,
  editRightsEnforced: boolean
): boolean =>
  lane === "creator" ||
  lane === "admin" ||
  (lane === "coach" && !editRightsEnforced && coachHasGrant);
